import '@availity/yup';
import * as yup from 'yup';

const formValidation = () =>
  yup.object().shape({
    code: yup
      .string()
      .required('Il codice sconto è obbligatorio')
      .min(6, 'Il codice deve essere di almeno 6 caratteri')
      .max(20, 'Il codice non può superare i 20 caratteri')
      .matches(
        /^[A-Z0-9]+$/,
        'Il codice può contenere solo lettere maiuscole (A-Z) e numeri (0-9)',
      ),
    description: yup
      .string()
      .max(255, 'La descrizione non può superare i 255 caratteri'),
    discountPercentage: yup
      .number()
      .required('La percentuale di sconto è obbligatoria')
      .min(0, 'La percentuale deve essere maggiore o uguale a 0')
      .max(100, 'La percentuale non può superare 100'),
    maxUses: yup
      .number()
      .integer('Il numero deve essere un intero')
      .min(1, 'Il numero massimo di utilizzi deve essere almeno 1')
      .nullable()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value,
      ),
    expirationDate: yup
      .date()
      .min(new Date(), 'La data di scadenza deve essere futura')
      .nullable()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value,
      ),
    disableAutoRenewal: yup.boolean(),
    isActive: yup.boolean().required(),
  });

export default formValidation;
